import { Formik, Form, Field } from 'formik';
import { useNavigate } from 'react-router-dom';
import useOrgs from './hooks/useOrgs';
import { toast } from 'sonner';
import { Button } from '@/src/shadComponents/ui/button';
import { Input } from '@/src/shadComponents/ui/input';
import { Label } from '@/src/shadComponents/ui/label';
import { Card, CardContent } from '@/src/shadComponents/ui/card';
import { Loader2 } from 'lucide-react';
import PageShell from '@/src/Common/components/PageShell';

interface OrgFormValues {
    name: string;
    logo?: string;
}

export default function OrgCreate() {
    const initialValues: OrgFormValues = {
        name: '',
        logo: '',
    };

    const navigate = useNavigate();

    const { createOrg } = useOrgs();
    return (
        <PageShell
            title="Create Organization"
            breadcrumbs={[
                { label: 'Admin', href: '/admin/orgs' },
                { label: 'Organizations', href: '/admin/orgs' },
                { label: 'Create' },
            ]}
        >
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, actions) => {
                    const org = await createOrg(values);
                    actions.setSubmitting(false);

                    if (org.id) {
                        navigate(`/admin/orgs/${org.id}`);
                        toast.success('Organization created successfully');
                    }
                }}
            >
                {(props) => (
                    <Form
                        className="mt-6"
                        placeholder={undefined}
                        onPointerEnterCapture={undefined}
                        onPointerLeaveCapture={undefined}
                    >
                        <div className="space-y-12">
                            <div className="grid grid-cols-1 gap-x-8 gap-y-10  pb-12 md:grid-cols-3">
                                <div className="px-8">
                                    <h2 className="text-lg font-semibold tracking-tight text-foreground">
                                        Basic Details
                                    </h2>
                                    <p className="mt-1 text-sm leading-6 text-muted-foreground">
                                        Basic details about the organization.
                                    </p>
                                </div>
                                <Card className="md:col-span-2">
                                    <CardContent className="pt-6 space-y-6">
                                        <div className="space-y-2">
                                            <Label htmlFor="name">Name</Label>
                                            <Field
                                                as={Input}
                                                id="name"
                                                name="name"
                                                placeholder="Organization Name"
                                            />
                                        </div>
                                    </CardContent>
                                </Card>
                            </div>
                        </div>
                        <div className="flex items-center justify-end gap-4 pt-6">
                            <Button
                                type="button"
                                variant="ghost"
                                onClick={() => navigate(-1)}
                            >
                                Cancel
                            </Button>

                            <Button
                                type="submit"
                                disabled={props.isSubmitting}
                            >
                                {props.isSubmitting && <Loader2 className="size-4 animate-spin" />}
                                Create
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </PageShell>
    );
}
